import React, { useEffect } from "react";
import Hero from "../components/Hero";
import { Ethos, FeaturedGallery } from "../components/Ethos.";
import BioSection from "../components/Bio";
import ColorPalette from "../components/ColorPallet";
import FilmStrip from "../components/FilmStrip";
import WorkWithMe from "../components/WorkWithMe";
import { Helmet } from "react-helmet-async";
import Packages from "../components/Packages";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Helmet>
        <title>StillsByHasanka | Natural Light Photographer in Sri Lanka</title>
        <meta
          name="description"
          content="Capture your story with Hasanka. Premier natural light and vintage aesthetic photography in Sri Lanka, specializing in weddings, portraits, and nature."
        />
        <meta
          name="keywords"
          content="Photographer Sri Lanka, Best photographer Colombo, Wedding photography Kurunegala, Natural light photography Sri Lanka, StillsByHasanka"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="StillsByHasanka | Capturing Light in Sri Lanka"
        />
        <meta
          property="og:description"
          content="Dreamy, vintage-inspired photography based in Sri Lanka. Available for sessions in Colombo, Kurunegala, and island-wide."
        />
        <meta
          property="og:image"
          content="https://stillsbyhasanka.com/og-home.jpg"
        />

        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": "StillsByHasanka",
              "image": "https://stillsbyhasanka.com/logo.jpg",
              "@id": "",
              "url": "https://stillsbyhasanka.com",
              "telephone": "+94787784795",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Your Street Address",
                "addressLocality": "Kurunegala",
                "addressRegion": "North Western Province",
                "addressCountry": "LK"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 7.4818, 
                "longitude": 80.3609
              },
              "servesCuisine": "",
              "areaServed": [
                {"@type": "City", "name": "Kurunegala"},
                {"@type": "City", "name": "Colombo"},
                {"@type": "Country", "name": "Sri Lanka"}
              ],
              "priceRange": "$$"
            }
          `}
        </script>
      </Helmet>
      <Hero />
      <Ethos />
      <FeaturedGallery />
      <Packages />
      <BioSection />
      <FilmStrip />
      <ColorPalette />
      <WorkWithMe />
    </div>
  );
};

export default Home;
